import { SipTopBannerModule } from './../common/sip-top-banner/sip-top-banner.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SharedModule } from '../shared/shared.module';
import { CommonFundraiserModule } from '../common/common-fundraiser/common-fundraiser.module';
/**Main Compoennts */
import {
  FundraiserComponent,
} from './components/index';
const AppCommonModules = [
  InputModule, CommentCardModule, DonateNowModule, DonorModule,
  FbShareModule, FrCardModule, FrHeaderModule,
  ProgressBarModule, UpdateModule, ButtonModule, WhatsappShareModule,
  PlaceholderLoaderModule, FooterModule, InnerTemplaterModule,
  DocumentModule, DonationMethodsModule, SupportCardModule, ViewSupportersModule,
  ImgSliderModule, ContactDialogModule, CommonHeaderModule, EndFundraiserBannerModule,
  ThankyouBannerModule, SocialShareBtnModule, SocialShareModule, PaymentModule, WidgetModule,
  ChatWithUsModule, SupportingFrModule, SimilarFundraiserModule, MatchingDonationCardModule, TickrModule,
  PreApproveBannerModule, CampaignerInfoModule, CommonFundraiserModule, FundraiserSliderModule,
  FrBeneficiaryCardModule, CouponInfoModule, FundraiserSIPBannerModule, EndedFundraiserSipDialogModule, SipTopBannerModule,
  FollowCampaignModule, PaymentOtdModule, FaqsModule,
  StoryAbComponent
];
/**Routing Module */
import { FundraiserRoutingModule } from './fundraiser-routing.module';
import { PrivateFundraiserComponent } from './components/private-fundraiser/private-fundraiser.component';
import { MemorialNudgeComponent } from './components/memorial-nudge/memorial-nudge.component';
import { FollowCampaignModule } from '../common/follow-campaign/follow-campaign.module';
import { InViewportModule } from 'ng-in-viewport';
import { ButtonModule } from '../common/button/button.module';
import { CampaignerInfoModule } from '../common/campaigner-info/campaigner-info.module';
import { CaptchaInputModule } from '../common/captcha-input/captcha-input.module';
import { ChatWithUsModule } from '../common/chat-with-us/chat-with-us.module';
import { CloseBtnModule } from '../common/close-btn/close-btn.module';
import { CommentCardModule } from '../common/comment-card/comment-card.module';
import { CommonHeaderModule } from '../common/common-header/common-header.module';
import { ContactDialogModule } from '../common/contact-dialog/contact-dialog.module';
import { CouponInfoModule } from '../common/coupon-info/coupon-info.module';
import { DocumentModule } from '../common/document/document.module';
import { DonateNowModule } from '../common/donate-now/donate-now.module';
import { DonationMethodsModule } from '../common/donation-methods/donation-methods.module';
import { DonorModule } from '../common/donor/donor.module';
import { EndFundraiserBannerModule } from '../common/end-fundraiser-banner/end-fundraiser-banner.module';
import { EndedFundraiserSipDialogModule } from '../common/ended-fundraiser-sip-dialog/ended-fundraiser-sip-dialog.module';
import { FbShareModule } from '../common/fb-share/fb-share.module';
import { FooterModule } from '../common/footer/footer.module';
import { FrBeneficiaryCardModule } from '../common/fr-beneficiary-card/fr-beneficiary-card.module';
import { FrCardModule } from '../common/fr-card/fr-card.module';
import { FrHeaderModule } from '../common/fr-header/fr-header.module';
import { FundraiserSIPBannerModule } from '../common/fundraiser-sipbanner/fundraiser-sipbanner.module';
import { FundraiserSliderModule } from '../common/fundraiser-slider/fundraiser-slider.module';
import { ImgSliderModule } from '../common/img-slider/img-slider.module';
import { InnerTemplaterModule } from '../common/inner-templater/inner-templater.module';
import { InputModule } from '../common/input/input.module';
import { MatchingDonationCardModule } from '../common/matching-donation-card/matching-donation-card.module';
import { PaymentModule } from '../common/payment/payment.module';
import { PlaceholderLoaderModule } from '../common/placeholder-loader/placeholder-loader.module';
import { PreApproveBannerModule } from '../common/pre-approve-banner/pre-approve-banner.module';
import { ProgressBarModule } from '../common/progress-bar/progress-bar.module';
import { SimilarFundraiserModule } from '../common/similar-fundraiser/similar-fundraiser.module';
import { SocialShareBtnModule } from '../common/social-share-btn/social-share-btn.module';
import { SocialShareModule } from '../common/social-share/social-share.module';
import { SupportCardModule } from '../common/support-card/support-card.module';
import { SupportingFrModule } from '../common/supporting-fr/supporting-fr.module';
import { ThankyouBannerModule } from '../common/thankyou-banner/thankyou-banner.module';
import { TickrModule } from '../common/tickr/tickr.module';
import { UpdateModule } from '../common/update/update.module';
import { ViewSupportersModule } from '../common/view-supporters/view-supporters.module';
import { WhatsappShareModule } from '../common/whatsapp-share/whatsapp-share.module';
import { WidgetModule } from '../common/widget/widget.module';
import { PaymentOtdModule } from '../common/payment-otd/payment-otd.module';
import { FundraiserSliderImgModule } from '../common/fundraiser-slider-img/fundraiser-slider-img.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { ComponentLoader } from '../core/component-loader/component-loader.component';
import { FaqsModule } from '../common/faqs/faqs.module';
import { ExtraProductSelectComponent } from '../core/extra-product-select/extra-product-select.component';
import { StoryAbComponent } from './components/story-ab/story-ab.component';
import { StoryModule } from '../story/story.module';
import {EndedFundraiserV2Component} from '../common/ended-fundraiserV2/ended-fundraiser-v2.component'
import { SupportersComponent } from '../common/supporters/supporters.component';
import { SafeUrlPipe } from '../shared/pipes/safe-url/safe-url.pipe';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FundraiserRoutingModule,
    InViewportModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    SharedModule,
    SwiperModule,
    ...AppCommonModules,
    CloseBtnModule,
    CaptchaInputModule,
    FundraiserSliderImgModule,
    ModuleLoaderModule,
    ExtraProductSelectComponent,
    ComponentLoader,
    StoryModule,
    EndedFundraiserV2Component,
    SupportersComponent,
    SafeUrlPipe
  ],
  declarations: [
    FundraiserComponent,
    PrivateFundraiserComponent,
    MemorialNudgeComponent
  ],
  exports: [
    FundraiserComponent
  ]
})
export class FundraiserModule { }
